import React from "react";
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Col, Row} from "reactstrap";
import Widget from "../CreateNewEvent/AddVolunteers/DualList/widget";
import {Button, Icon, Input} from "semantic-ui-react";

class ReservationDetailsModal extends React.Component {

  state = {
    name: ""
  };

  removeFromTheSeat = () => {
    let check_name = `${ this.props.value.firstName } ${ this.props.value.lastName }`;
    if(check_name === this.state.name) {
      this.props.removeFromTheSeat( this.props.seat );
    }
  };

  //toggle
  toggle = () => {
  };

  render() {
    return(
      <div>
        <MDBModal isOpen={true} toggle={this.toggle}>
          <MDBModalHeader className={"title"} toggle={this.props.closeReservationModal}>Seat No: { this.props.seat } Reservation</MDBModalHeader>
          <MDBModalBody>
            <table className={"reservation-tbl"}>
              <tbody className={"reservation-tbl-tbody"}>
              <tr className={"reservation-tbl-tr"}>
                <th className={"reservation-text-align reservation-tbl-th"}>Seat No</th>
                <td className={"reservation-text-align reservation-tbl-td"}>{ this.props.seat }</td>
              </tr>
                <tr className={"reservation-tbl-tr"}>
                  <th className={"reservation-text-align reservation-tbl-th"}>Full Name</th>
                  <td className={"reservation-text-align reservation-tbl-td"}>{ `${ this.props.value.firstName } ${ this.props.value.lastName }` }</td>
                </tr>
              <tr className={"reservation-tbl-tr"}>
                <th className={"reservation-text-align reservation-tbl-th"}>Email</th>
                <td className={"reservation-text-align reservation-tbl-td"}>{ `${ this.props.value.email }` }</td>
              </tr>
              <tr className={"reservation-tbl-tr"}>
                <th className={"reservation-text-align reservation-tbl-th"}>Mobile</th>
                <td className={"reservation-text-align reservation-tbl-td"}>{ `${ this.props.value.mobile }` }</td>
              </tr>
              <tr className={"reservation-tbl-tr"}>
                <th className={"reservation-text-align reservation-tbl-th"}>Points</th>
                <td className={"reservation-text-align reservation-tbl-td"}>{ `${ this.props.value.points }` }</td>
              </tr>
              </tbody>
            </table>
            <hr/>
            <div>
              <p>If you want remove this participant from this seat, <br/> please type the <strong>"{ `${ this.props.value.firstName } ${ this.props.value.lastName }`}"</strong> here and click the remove button.</p>
              <input placeholder='Type the participant name here to remove' onChange={ e => this.setState({name: e.target.value}) } style={{width: '100%'}} />
            </div>
            <div className={"reservation-btn-align"}>
              <Button color='red'
                      onClick={ this.removeFromTheSeat }
                      disabled={
                        (`${ this.props.value.firstName } ${ this.props.value.lastName }` === this.state.name) ? false : true
                      }
              >
                <Icon name='trash' />
                Remove
              </Button>
            </div>
          </MDBModalBody>
        </MDBModal>
      </div>
    )
  }

}

export default ReservationDetailsModal;
